import { API } from "."
import { ReadCountryListResponse, ReadDownloadListResponse } from "@/types/util"

export async function readCountryList() {
  return await API.get<ReadCountryListResponse>("/util/countries")
}

export async function readDownloadList() {
  return await API.get<ReadDownloadListResponse>("/util/downloads")
}
